import { guideSvg } from '../assets'
import Footer from 'components/Footer'
import Header from 'components/Header'
import s from './community_guide.module.sass'

export default function Page() {
  return <div className={s['community-ct']}>
    <Header />
    <div className={s['community']}>
      <img src={guideSvg}></img>
    </div>
    <Footer></Footer>
  </div>
}